(function () {
  'use strict';

  const style = document.createElement('style');
  style.textContent = `
    .vyro-animate {
      opacity: 0;
      transform: translateY(40px);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }
    .vyro-animate.vyro-visible {
      opacity: 1;
      transform: translateY(0);
    }
    .vyro-stagger > * {
      opacity: 0;
      transform: translateY(30px);
      transition: opacity 0.5s ease, transform 0.5s ease;
    }
    .vyro-stagger.vyro-visible > *:nth-child(1) { transition-delay: 0.05s; }
    .vyro-stagger.vyro-visible > *:nth-child(2) { transition-delay: 0.15s; }
    .vyro-stagger.vyro-visible > *:nth-child(3) { transition-delay: 0.25s; }
    .vyro-stagger.vyro-visible > *:nth-child(4) { transition-delay: 0.35s; }
    .vyro-stagger.vyro-visible > *:nth-child(5) { transition-delay: 0.45s; }
    .vyro-stagger.vyro-visible > *:nth-child(6) { transition-delay: 0.55s; }
    .vyro-stagger.vyro-visible > *:nth-child(7) { transition-delay: 0.65s; }
    .vyro-stagger.vyro-visible > *:nth-child(8) { transition-delay: 0.75s; }
    .vyro-stagger.vyro-visible > * {
      opacity: 1;
      transform: translateY(0);
    }
    .vyro-hero__headline {
      opacity: 0;
      transform: translateY(30px) scale(0.97);
      transition: opacity 0.8s ease, transform 0.8s ease;
    }
    .vyro-hero-loaded .vyro-hero__headline {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    .vyro-hero__copy .vyro-eyebrow {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s;
    }
    .vyro-hero__copy .vyro-hero__sub {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s;
    }
    .vyro-hero__copy .vyro-hero__actions {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.6s ease 0.7s, transform 0.6s ease 0.7s;
    }
    .vyro-hero-loaded .vyro-hero__copy .vyro-eyebrow,
    .vyro-hero-loaded .vyro-hero__copy .vyro-hero__sub,
    .vyro-hero-loaded .vyro-hero__copy .vyro-hero__actions {
      opacity: 1;
      transform: translateY(0);
    }
    .vyro-hero__visual {
      opacity: 0;
      transform: translateX(40px) rotate(1.5deg);
      transition: opacity 0.9s ease 0.3s, transform 0.9s ease 0.3s;
    }
    .vyro-hero-loaded .vyro-hero__visual {
      opacity: 1;
      transform: translateX(0) rotate(1.5deg);
    }
    .vyro-rack__title,
    .vyro-grid__title {
      opacity: 0;
      transform: translateX(-30px);
      transition: opacity 0.6s ease, transform 0.6s ease;
    }
    .vyro-section-loaded .vyro-rack__title,
    .vyro-section-loaded .vyro-grid__title {
      opacity: 1;
      transform: translateX(0);
    }
    @media (prefers-reduced-motion: reduce) {
      .vyro-animate,
      .vyro-stagger > *,
      .vyro-hero__headline,
      .vyro-hero__copy .vyro-eyebrow,
      .vyro-hero__copy .vyro-hero__sub,
      .vyro-hero__copy .vyro-hero__actions,
      .vyro-hero__visual,
      .vyro-rack__title,
      .vyro-grid__title {
        opacity: 1 !important;
        transform: none !important;
        transition: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  function prepareElements() {
    document.querySelectorAll('.vyro-marquee, .vyro-rack, .vyro-grid').forEach(el => {
      el.classList.add('vyro-animate');
    });
    document.querySelectorAll('.vyro-grid__items').forEach(el => {
      el.classList.add('vyro-stagger');
    });
    document.querySelectorAll('.vyro-rack__track').forEach(el => {
      el.classList.add('vyro-stagger');
    });
    document.querySelectorAll('.vyro-rack, .vyro-grid').forEach(el => {
      el.classList.add('vyro-animate');
    });
  }

  function setupScrollObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('vyro-visible');
          if (entry.target.classList.contains('vyro-rack') ||
              entry.target.classList.contains('vyro-grid')) {
            entry.target.classList.add('vyro-section-loaded');
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('.vyro-animate, .vyro-stagger').forEach(el => {
      observer.observe(el);
    });
  }

  function triggerHeroAnimation() {
    const hero = document.querySelector('.vyro-hero');
    if (!hero) return;
    setTimeout(() => {
      hero.classList.add('vyro-hero-loaded');
    }, 100);
  }

  function addCardHoverEffects() {
    document.querySelectorAll('.vyro-grid__card, .vyro-rack__item').forEach(card => {
      card.style.transition = 'transform 0.2s ease, box-shadow 0.2s ease';
      card.addEventListener('mouseenter', () => {
        card.style.transform = 'translateY(-6px)';
        card.style.boxShadow = '0 12px 32px rgba(10,165,165,0.15)';
      });
      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
        card.style.boxShadow = '';
      });
    });
  }

  function init() {
    prepareElements();
    setupScrollObserver();
    triggerHeroAnimation();
    addCardHoverEffects();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();